import { render, staticRenderFns } from "./SfBanner.vue?vue&type=template&id=7566776e&"
import script from "./SfBanner.vue?vue&type=script&lang=js&"
export * from "./SfBanner.vue?vue&type=script&lang=js&"
import style0 from "./SfBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports